import React, { useEffect } from 'react';
import moment from 'moment';

const AntdDatePicker = ({
  fieldName,
  dateState,
  setDateState,
  setValue,
  errors,
  setError,
  clearErrors,
  errMsg,
  selectedObject,
  selectedDateKeyName,
  OldDate
}) => {
  function onDateChange(event) {
    const selectedDate = event.target.value;
    if (selectedDate) {
      const formattedDate = moment(selectedDate, 'YYYY-MM-DD').toDate();
      
      setDateState(formattedDate);
      setValue(fieldName, formattedDate);
      clearErrors(fieldName);
    } else {
      setError(fieldName, errMsg);
    }
  }

  useEffect(() => {
    if (dateState) {
      setValue('expiration_date', dateState);
    }
  }, [dateState, setValue]);

  useEffect(() => {
    if (selectedObject && selectedObject[selectedDateKeyName] && !dateState) {
      setValue(
        fieldName,
        moment(selectedObject[selectedDateKeyName], 'YYYY-MM-DD').toDate()
      );
    }
  }, [selectedObject, selectedDateKeyName, fieldName, setValue, dateState]);

  return (
    <div className="date-picker-wrap">
      <p className="label-p">تاريخ انتهاء الصلاحية ( {OldDate?moment(OldDate).locale('en').format("YYYY-MM-DD"):""})</p>
      <input
        type="date"
        onChange={onDateChange}
        value={dateState?moment(dateState).locale('en').format("YYYY-MM-DD"):""} // استخدام `value` لضبط التاريخ
      />

      {errors && errors[fieldName] && (
        <p className="error-p">{errors[fieldName].message}</p>
      )}
    </div>
  );
};

export default AntdDatePicker;
